import { useAuthStore } from "@/stores/useAuthStore"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useRouter } from "@tanstack/react-router"

export const useLogout = () => {
  const queryClient = useQueryClient()
  const authStoreLogout = useAuthStore((state) => state.logout)
  const router = useRouter()

  return useMutation({
    mutationFn: async () => {
      authStoreLogout()
      Promise.resolve().then(() => queryClient.clear())
    },
    onSuccess: () => {
      router.navigate({ to: "/login" })
    },
  })
}
